import { HEADER_ROLES, type ClassifiedLine } from "../types";

interface LineSegment {
  type: "cited" | "context";
  lines: ClassifiedLine[];
}

export const segmentLines = (
  classified: ClassifiedLine[],
  highlights: Set<number>
): LineSegment[] => {
  const segments: LineSegment[] = [];
  let current: LineSegment | null = null;

  for (const line of classified) {
    if (HEADER_ROLES.has(line.role) && !highlights.has(line.num)) continue;

    const type = highlights.has(line.num) ? "cited" : "context";

    if (!current || current.type !== type) {
      current = { type, lines: [] };
      segments.push(current);
    }
    current.lines.push(line);
  }

  return segments;
};
